import { Controller } from "@hotwired/stimulus";
import moment from "moment";

/**
 * Handles token expiry selection, toggling a custom date picker and
 * syncing the chosen expiry as days into a hidden field for form submission.
 */
export default class extends Controller {
  static targets = ["select", "customDate", "hiddenDays", "datePicker"];

  declare readonly selectTarget: HTMLSelectElement;
  declare readonly customDateTarget: HTMLElement;
  declare readonly hiddenDaysTarget: HTMLInputElement;
  declare readonly datePickerTarget: HTMLInputElement;

  connect() {
    this.updateState(false);
  }

  selectChanged() {
    this.updateState(true);
  }

  dateChanged() {
    const days = moment(this.datePickerTarget.value).diff(moment(), "days") + 1;
    this.hiddenDaysTarget.value = days > 0 ? String(days) : "";
  }

  private updateState(resetDate: boolean) {
    const isCustom = this.selectTarget.value === "custom";
    this.customDateTarget.classList.toggle("hidden", !isCustom);
    this.datePickerTarget.required = isCustom;

    if (resetDate) {
      this.datePickerTarget.value = "";
    }

    this.hiddenDaysTarget.value = isCustom ? "" : this.selectTarget.value;
  }
}
